import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        toolbar: {
            justifyContent: 'space-between !important',
            background: theme.palette.secondary[50],
            padding: `${theme.spacing(2)} ${theme.spacing(1)} !important`,
            minHeight: `${theme.spacing(4.5)} !important`,
        },
        buttonsContainer: {
            display: 'flex',
            alignItems: 'center',
            '&& .MuiIconButton-root': {
                padding: '6px !important',
                height: '30px !important',
                width: '30px !important',
            },
        },
        action: {
            padding: '6px',
        },
        filter: {
            color: theme.palette.secondary[600],
        },
        dropdown: {
            '& .MuiMenu-list': {
                padding: '0 !important',
            },
            '&& .MuiMenuItem-root': {
                borderBottom: `1px solid ${theme.palette.secondary[200]} !important`,
                whiteSpace: 'wrap !important',
                '&:hover': {
                    backgroundColor: `${theme.palette.primary[50]} !important`,
                },
                padding: '8px 10px 8px 12px !important',
            },
        },
    }
})

export default useStyles
